import React from 'react';
import PropTypes from 'prop-types';
import { withTracker } from 'meteor/react-meteor-data';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty } from 'lodash';
import { Col, Row } from 'react-bootstrap';
import { getType } from '../../../api/Graphics/graphic-operations';

import Layers from '../../../api/Layers/Layers';
import Graphics from '../../../api/Graphics/Graphics';

import loadTableLayer from '../../../modules/load-table-layer';
import { GRAPH_ELEMENTS } from '../../../modules/graphic-elements';
import getGraphicProps from '../../../modules/get-graphic-props';
import Loading from '../Loading';

const ViewGraphicsComponent = props => {
  const { aspectRatio, layer, graphic, modal } = props;
  const [height, setHeight] = React.useState(window.innerHeight / 2);
  const [width, setWidth] = React.useState(window.innerWidth);
  const [attributes, setAttributes] = React.useState();
  const [values, setValues] = React.useState([]);

  const loadAttributes = async () => {
    try {
      const { tableBody, tableTitle } = await loadTableLayer(layer);
      setAttributes(tableTitle);
      setValues(tableBody);
    } catch (error) {
      Bert.alert(error.message, 'danger');
    }
  };

  const updateDimensions = () => {
    const heightAux = modal ? window.innerHeight * 0.75 : window.innerHeight / 2;
    const widthAux = modal ? window.innerWidth / 2 : window.innerWidth / 4;
    setHeight(heightAux);
    setWidth(widthAux);
  };
  React.useEffect(() => {
    loadAttributes();
    updateDimensions();
  }, [graphic, layer]);
  const graphicProps = getGraphicProps({
    width,
    height,
    graphic,
    attributes,
    values,
    verticalPadding: false,
    aspectRatio
  });
  const { value } = GRAPH_ELEMENTS.properties[getType(graphic)];
  const previewWithProps = React.cloneElement(value, { ...graphicProps });

  if (isEmpty(graphic)) return <Loading />;

  return (
    <>
      <Row>
        <Col xs={12}>{previewWithProps}</Col>
      </Row>
    </>
  );
};

ViewGraphicsComponent.defaultProps = {
  aspectRatio: 1 / 3,
  graphic: {},
  layer: {},
  modal: false
};

ViewGraphicsComponent.propTypes = {
  aspectRatio: PropTypes.number,
  graphic: PropTypes.object,
  layer: PropTypes.object,
  modal: PropTypes.bool
};

export default withTracker(({ layerId, graphicId }) => {
  const A = Graphics.findOne(graphicId);
  const B = Layers.findOne(layerId);

  return {
    graphic: A,
    layer: B
  };
})(ViewGraphicsComponent);
